"use client"

import Image from "next/image"
import React from "react"

import { cloudinaryLoader } from "../cloudinary-loader"

import * as styles from "./Tile.css"

type TileProps = {
  imagePath: string
  altText?: string
  title?: string
  link?: string
  onClick?: () => void
  renderLink?: (props: {
    href: string
    children: React.ReactNode
    className?: string
    "data-title"?: string
    onClick?: () => void
  }) => React.ReactNode
}

export const Tile: React.FC<TileProps> = ({
  imagePath,
  altText,
  title,
  link,
  onClick,
  renderLink,
}) => {
  const content = (
    <>
      <div className={styles.imageContainer}>
        {imagePath ? (
          <Image
            className={styles.image}
            data-testid="next-image"
            src={imagePath}
            alt={altText ?? ""}
            unoptimized={process.env.STORYBOOK === "true"}
            quality={85}
            width={102}
            height={102}
            priority
            sizes="102px"
            loader={cloudinaryLoader}
          />
        ) : (
          <div className={styles.image} />
        )}
      </div>

      {title !== undefined && (
        <div className={title ? styles.text : styles.missingText}>{title}</div>
      )}
    </>
  )

  if (link && renderLink) {
    return (
      <div className={styles.tileContainer}>
        {renderLink({
          href: link,
          className: styles.linkStyle,
          "data-title": title,
          onClick,
          children: content,
        })}
      </div>
    )
  }

  return (
    <div className={styles.tileContainer} onClick={onClick}>
      {content}
    </div>
  )
}
